export interface DateFilterPreset {
  id: string
  label: string
}

export const DATE_FILTER_PRESETS: DateFilterPreset[] = [
  { id: 'today', label: 'Сегодня' },
  { id: 'yesterday', label: 'Вчера' },
  { id: 'current_week', label: 'Текущая неделя' },
  { id: 'last_week', label: 'Прошлая неделя' },
  { id: 'current_month', label: 'Текущий месяц' },
  { id: 'last_month', label: 'Прошлый месяц' },
]
